<script>
import { mapGetters, mapMutations } from 'vuex'
import stepMixin from '../../mixins/stepMixin'
import checkCart from '../../mixins/checkCart'
import {$post} from '../../http/index'

export default {
	mixins: [stepMixin,checkCart],
	data() {
		return {
			form: {
				name: '',
				phone: '',
				zone: '',
				address: '',
				payment: 'tarjeta',
				name_holder:'',
                cardnumber:'',
                expiredate:'',
                cvv:'',
                token:'',
                email:'',
                monto:0,
			},
			finish: false,
			error:false,
			shipping:2.5
		}
	},
	computed: {
		checkData() {
			if (this.form.name && this.form.phone && this.form.zone && this.form.address && this.form.email) {
				if(this.form.payment=='efectivo'){
					return true
				}
				else{
					if(this.form.name_holder && this.form.cardnumber && this.form.expiredate && this.form.cvv){
						return true
					}
				}
			}

			return false
		},

		year() {
			let date = new Date()

			return date.getFullYear()
		},

		submitCart() {
			let cart = []
			this.cart.hotdogs.forEach(hotdog => {
				cart.push({id: hotdog.id, type: 1, qty: hotdog.qty})
			});
			this.cart.drinks.forEach(drink => {
				cart.push({id: drink.id, type: 3, qty: drink.qty})
			});
			this.cart.sides.forEach(side => {
				cart.push({id: side.id, type: 2, qty: side.qty})
			});

			return cart
		},
		...mapGetters({
			cart: 'cart',
			totalCart: 'totalCart',
			zones: 'zones'
		})
	},

	methods: {
		async finihsOrder() {
			let $api = $post
			this.form.monto=this.totalCart+this.shipping;
			let form = JSON.stringify(this.form)
				form = JSON.parse(form)
				form.cart = this.submitCart
			// 1->panes
			// 2->complementos
			// 3->bebidas
			// 4->otros
			
			this.addLoader('Procesando orden por favor espere...')
		
			try {
				let data = await $api.order(form)
				console.log(data)
				this.removeLoader()
				this.finish = true
				this.resetCart()
			} catch (error) {
				this.error=true;
				this.removeLoader()
			}
		},
		selectedShipping(){
			this.zones.forEach(element => {
				if(element.name==this.form.zone){
					this.shipping=element.value;
				}
			});
		},
		backorder(){
			this.error=false;
			this.finish=false;
		},
        addCharacterExpireDate(){
            if(this.form.expiredate.length==2 ){
                this.form.expiredate=this.form.expiredate+"/"
            }
        },
		...mapMutations({
			removeOnCart: 'removeOnCart',
			addLoader: 'addLoader',
			removeLoader: 'romoveLoader',
			resetCart: 'resetCart'
		})
	}
}
</script>
<template>
<div>
	<div v-if="!finish && !error">
		<div class="alert">
				<div class="section__container py-2">
					<h5 class="text-center m-0 text-bold">Verifique su pedido y complete la información - Paso 4/4</h5>
				</div>
		</div>
		<div class="d-flex justify-content-center flex-wrap px-2 px-xl-5 py-5">
			<div class="col-12 col-md-6 col-lg-4 col-xl-3 order-2 order-lg-1 px-2  px-lg-3 px-xl-3">
				<h3 class="title">Datos para la entrega</h3>
				<div class="d-flex flex-wrap row-form">
					<div class="col-12 p-2">
						<label class="input">
							<span class="input__label">Nombre quien recibe</span>
							<input class="input__control" type="text" v-model="form.name">
						</label>
					</div>
					<div class="col-12 p-2">
						<label class="input">
							<span class="input__label">Email</span>
							<input class="input__control" type="text" v-model="form.email">
						</label>
					</div>
					<div class="col-12 col-lg-6 p-2">
						<label class="input">
							<span class="input__label">Teléfono</span>
							<input class="input__control" type="text" v-model="form.phone" v-mask="'####-####'">
						</label>
					</div>
					<div class="col-12 col-lg-6 p-2">
						<label class="input">
							<span class="input__label">Zona</span>
							<select class="input__control" type="text" v-model="form.zone" @change="selectedShipping()">
								<option value="">Selecciona Zona</option>
								<option v-for="(zone, index) in zones" :key="`zone_${index}`" :value="zone.name">{{zone.name}}</option>
							</select>
						</label>
					</div>
					<div class="col-12 p-2">
						<label class="input">
							<span class="input__label">Dirección exacta</span>
							<textarea class="input__control" id=""  rows="4" v-model="form.address"></textarea>
						</label>
					</div>
					<div class="col-12 p-2">
						<p class="m-0 font-weight-bold">Su costo de envío: <span class="text-primary">${{shipping}}</span></p>
					</div>
				</div>
			</div>
			<div class="col-12 col-lg-4 col-xl-6 order-1 order-lg-2 px-2 px-xl-3">
				<h3 class="title">Su pedido</h3>
				<div class="d-flex">
					<div class="col-2 text-center font-weight-bold">Cant.</div>
					<div class="col-6 text-center font-weight-bold">Detalle</div>
					<div class="col-3 text-center font-weight-bold">Monto</div>
					<div class="col-1 text-center font-weight-bold"></div>
				</div>
				<div>
					<div class="d-flex align-items-stretch  table__row" v-for="(item, index) in cart.hotdogs" :key="`cart-hotdogs-${index}`">
						<div class="col-2 p-1 text-center font-weight-bold">
							<div class="table__cell">
								{{item.qty}}
							</div>
						</div>
						<div class="col-6 p-1  font-weight-bold">
							<div class="table__cell">
								<h4 class="m-0">Panshito</h4>
								<p class="item-cart__name m-0">{{item.title}}</p>
							</div>
						</div>
						<div class="col-3 p-1 text-center text-primary">
							<div class="table__cell font-weight-bold">
								{{Number(item.price) * item.qty | numeral('$0,0.00')}}
							</div>
						</div>
						<div class="col-1 p-1 text-center font-weight-bold">
							<div class="table__cell">
								<button class="btn--transparent" @click="removeOnCart({id: item.id, type: 'hotdogs'})" v-if="cart.hotdogs.length > 1">
									<span class="icon-close text-primary"></span>
								</button>
							</div>
						</div>
					</div>
					<div class="d-flex align-items-stretch  table__row" v-for="(item, index) in cart.sides" :key="`cart-sides-${index}`">
						<div class="col-2 p-1 text-center font-weight-bold">
							<div class="table__cell">
								{{item.qty}}
							</div>
						</div>
						<div class="col-6 p-1  font-weight-bold">
							<div class="table__cell">
								<h4 class="m-0">Complemento</h4>
								<p class="item-cart__name m-0">{{item.title}}</p>
							</div>
						</div>
						<div class="col-3 p-1 text-center text-primary">
							<div class="table__cell font-weight-bold">
								{{Number(item.price) * item.qty | numeral('$0,0.00')}}
							</div>
						</div>
						<div class="col-1 p-1 text-center font-weight-bold">
							<div class="table__cell">
								<button class="btn--transparent" @click="removeOnCart({id: item.id, type: 'sides'})" >
									<span class="icon-close text-primary"></span>
								</button>
							</div>
						</div>
					</div>
					<div class="d-flex align-items-stretch  table__row" v-for="(item, index) in cart.drinks" :key="`cart-drinks-${index}`">
						<div class="col-2 p-1 text-center font-weight-bold">
							<div class="table__cell">
								{{item.qty}}
							</div>
						</div>
						<div class="col-6 p-1  font-weight-bold">
							<div class="table__cell">
								<h4 class="m-0">Bebida</h4>
								<p class="item-cart__name m-0">{{item.title}}</p>
							</div>
						</div>
						<div class="col-3 p-1 text-center text-primary">
							<div class="table__cell font-weight-bold">
								{{Number(item.price) * item.qty | numeral('$0,0.00')}}
							</div>
						</div>
						<div class="col-1 p-1 text-center font-weight-bold">
							<div class="table__cell">
								<button class="btn--transparent" @click="removeOnCart({id: item.id, type: 'drinks'})" >
									<span class="icon-close text-primary"></span>
								</button>
							</div>
						</div>
					</div>
				</div>
				<div class="d-flex border-top mt-3 py-3 px-2">
					<div class="col-8">
						<h3 class="font-weight-bold"><span>Total:</span></h3>
					</div>
					<div class="col-3">
						<h3 class="font-weight-bold text-center"><span class="text-primary">{{totalCart + shipping | numeral('$0,0.00')}}</span></h3>
					</div>
					<div class="col-1"></div>
				</div>
			</div>
			<div class="col-12 col-md-6 col-lg-4 col-xl-3 order-3 px-2 px-xl-3" style="height:100px">
				<h3 class="title">Pago</h3>
				<div>
					<label class="v-input-radio" v-if="false">
						<input type="radio" v-model="form.payment" value="efectivo" disabled>
						<span class="v-input-radio__check"></span>
						Efectivo, pago contra entrega.
					</label>
				</div>
				<div>
					<label class="v-input-radio">
						<input type="radio" v-model="form.payment" value="tarjeta">
						<span class="v-input-radio__check"></span>
						Tarjeta de crédito/débito.
					</label>
				</div>

				<div class="row row-form" v-if="form.payment=='tarjeta'" style="margin-top:20px">
					<h4 style="text-align: center;font-weight: bold;">Datos de Tarjeta de Credito</h4>
					<div style="display:flex;justify-content:center">
						<img src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI2LjIuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNhcGFfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgdmlld0JveD0iMCAwIDE5MjAgMTA4MCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTkyMCAxMDgwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6IzJDMkEyOTt9Cgkuc3Qxe2ZpbGw6IzIyNUU2Mzt9Cgkuc3Qye2ZpbGw6I0ZFRkVGRTt9Cgkuc3Qze2ZpbGw6IzJCQkM1RDt9Cgkuc3Q0e2ZpbGw6bm9uZTtzdHJva2U6IzJDMkEyOTtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9Cjwvc3R5bGU+CjxnPgoJPGc+CgkJPHBhdGggY2xhc3M9InN0MCIgZD0iTTM1MC43NSw0MzYuNjJjNi4zNS0xLjQzLDEyLjc3LTIuMTQsMTkuMjctMi4xNGM2LjY2LDAsMTMuMDksMC43MSwxOS4yNywyLjE0bC00MC45MywxNTYuMzMKCQkJYy03LjE0LDEuMjctMTQuMTIsMS45LTIwLjk0LDEuOWMtNi4xOSwwLTEzLjI1LTAuNjMtMjEuMTgtMS45TDI3Ny43LDQ4OC4wMWwtMjkuMDMsMTA0LjkzYy03LjE0LDEuMjctMTMuOTYsMS45LTIwLjQ2LDEuOQoJCQljLTYuMTksMC0xMy4yNS0wLjYzLTIxLjE4LTEuOWwtNDEuMTctMTU2LjMzYzYuNS0xLjQzLDEyLjkzLTIuMTQsMTkuMjctMi4xNGM2LjUsMCwxMi45MywwLjcxLDE5LjI3LDIuMTRsMjYuNjUsMTEwLjE3CgkJCWwyNS43LTExMC4xN2M2LjY2LTEuNDMsMTMuNjQtMi4xNCwyMC45NC0yLjE0YzcuMywwLDE0LjEyLDAuNzEsMjAuNDYsMi4xNGwzMC45MywxMTAuNjVMMzUwLjc1LDQzNi42MnoiLz4KCQk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNNDQ0LjgxLDU5NS4wOWMtMTIuNTMsMC0yMy40OC0yLjU0LTMyLjg0LTcuNjFjLTkuMzYtNS4wOC0xNi41OC0xMi4yOS0yMS42NS0yMS42NQoJCQljLTUuMDgtOS41Mi03LjYxLTIwLjQ2LTcuNjEtMzIuODRjMC0xMi41MywyLjYyLTIzLjQsNy44NS0zMi42YzUuMjMtOS4zNiwxMi41My0xNi41OCwyMS44OS0yMS42NQoJCQljOS41Mi01LjA4LDIwLjMtNy42MSwzMi4zNi03LjYxYzEyLjUzLDAsMjMuNDgsMi42MiwzMi44NCw3Ljg1YzkuMzYsNS4wOCwxNi41OCwxMi4yOSwyMS42NSwyMS42NQoJCQljNS4wOCw5LjM2LDcuNjEsMjAuMTUsNy42MSwzMi4zNmMwLDEyLjY5LTIuNTQsMjMuNzItNy42MSwzMy4wOGMtNS4wOCw5LjM2LTEyLjI5LDE2LjU4LTIxLjY1LDIxLjY1CgkJCUM0NjguMjksNTkyLjYzLDQ1Ny4zNCw1OTUuMDksNDQ0LjgxLDU5NS4wOXogTTQ0NC44MSw1NjQuMTZjOC40MSwwLDE0LjgzLTIuNjIsMTkuMjctNy44NWM0LjYtNS4zOSw2LjktMTMuMTcsNi45LTIzLjMyCgkJCWMwLTkuODMtMi4zLTE3LjQ1LTYuOS0yMi44NGMtNC42LTUuMzktMTEuMDItOC4wOS0xOS4yNy04LjA5Yy04LjA5LDAtMTQuNTIsMi43OC0xOS4yNyw4LjMzYy00LjYsNS4zOS02LjksMTIuOTMtNi45LDIyLjYKCQkJYzAsMTAuMTUsMi4zLDE3LjkzLDYuOSwyMy4zMkM0MzAuMTQsNTYxLjU0LDQzNi41Niw1NjQuMTYsNDQ0LjgxLDU2NC4xNnoiLz4KCQk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNNjUzLjUsNDcxLjM2YzEzLjMyLDAsMjQuMzUsMy4zMywzMy4wNyw5Ljk5YzguNzMsNi42NiwxMy4wOSwxNS41NSwxMy4wOSwyNi42NXY4NC43MWgtMzUuNDV2LTcyLjEKCQkJYzAtNi4xOS0xLjk4LTEwLjg3LTUuOTUtMTQuMDRjLTMuODEtMy4zMy05LjI4LTUtMTYuNDItNWMtNi4zNSwwLTEyLjQ1LDEuMTktMTguMzMsMy41N2MxLjkxLDUuMjMsMi44NiwxMC45NSwyLjg2LDE3LjEzdjcwLjQzCgkJCWgtMzUuNDZ2LTcyLjFjMC02LjE5LTEuOTgtMTAuODctNS45NS0xNC4wNGMtMy44LTMuMzMtOS4yOC01LTE2LjQyLTVjLTUuMzksMC0xMC40NywwLjYzLTE1LjIzLDEuOXY4OS4yM0g1MTcuNGwwLjI0LTEwNS44OQoJCQljNi45OC00LjkyLDE1LjU1LTguNzIsMjUuNy0xMS40MmMxMC4xNS0yLjcsMjAuMDctNC4wNCwyOS43NC00LjA0YzcuMywwLDE0LjEyLDEuMTksMjAuNDcsMy41N2M2LjM0LDIuMjIsMTEuOSw1LjM5LDE2LjY1LDkuNTIKCQkJYzYuMTktMy45NywxMy4xNy03LjE0LDIwLjk0LTkuNTJDNjM4LjkxLDQ3Mi41NSw2NDYuMzcsNDcxLjM2LDY1My41LDQ3MS4zNnoiLz4KCQk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNNzY4Ljc5LDQ3MS4zNmMyMS43MywwLDM4LjcxLDUuNzEsNTAuOTIsMTcuMTNjMTIuMzgsMTEuNDIsMTguNTYsMjcuNiwxOC41Niw0OC41NAoJCQljMCwxNy4yOS00LjI5LDMxLjMzLTEyLjg1LDQyLjEyYy04LjQsMTAuNjMtMjEuMTcsMTUuOTQtMzguMzEsMTUuOTRjLTUuNTUsMC0xMS4xOC0wLjg3LTE2Ljg5LTIuNjIKCQkJYy01LjcxLTEuOS0xMS4wMi00LjUyLTE1Ljk0LTcuODV2NDQuMDJjLTMuODEsMy4wMS05LjUyLDUuNzEtMTcuMTMsOC4wOWMtNy40NiwyLjM4LTEzLjcyLDMuNTctMTguOCwzLjU3VjQ4MC42NAoJCQljNi4wMy0yLjg2LDEzLjQ4LTUuMDgsMjIuMzctNi42NkM3NDkuNzUsNDcyLjIzLDc1OS4xMSw0NzEuMzYsNzY4Ljc5LDQ3MS4zNnogTTc3MS44OCw1NjUuMTFjOS45OSwwLDE3LjYxLTIuNTQsMjIuODUtNy42MQoJCQljNS4yNC01LjA4LDcuODUtMTMuMzMsNy44NS0yNC43NWMwLTkuNTItMi43LTE3LjM3LTguMDktMjMuNTZjLTUuMjQtNi4xOS0xMy4wOS05LjI4LTIzLjU2LTkuMjhjLTUuMjQsMC0xMC43OSwwLjQ4LTE2LjY2LDEuNDMKCQkJdjYyLjFDNzU5LjgzLDU2NC41NSw3NjUuNyw1NjUuMTEsNzcxLjg4LDU2NS4xMXoiLz4KCQk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNODY4LjgzLDQ1NS40MmMtNS4wNywwLTkuNDQtMS43NC0xMy4wOS01LjIzYy0zLjQ5LTMuNjUtNS4yNC04LjAxLTUuMjQtMTMuMDljMC01LjA4LDEuODItOS4zNiw1LjQ3LTEyLjg1CgkJCWMzLjY1LTMuNjUsNy45My01LjQ3LDEyLjg1LTUuNDdjNS4wNywwLDkuNDQsMS44MiwxMy4wOSw1LjQ3YzMuNjUsMy40OSw1LjQ3LDcuNzcsNS40NywxMi44NWMwLDQuOTItMS44Miw5LjItNS40NywxMi44NQoJCQlDODc4LjI3LDQ1My41OSw4NzMuOSw0NTUuNDIsODY4LjgzLDQ1NS40MnogTTg1MC45OCw0NzQuNjljNS4yNC0yLjIyLDExLjI2LTMuMzMsMTguMDgtMy4zM2M2LjY2LDAsMTIuNjEsMS4xMSwxNy44NCwzLjMzdjExOC4wMgoJCQloLTM1LjkzVjQ3NC42OXoiLz4KCQk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMjAxLjE2LDY1NS42MXYtMjQuNDVjMC0yLjQ2LDEuNzItNC41Niw0LjEzLTUuMDFjMTEuOTQtMi4xOSw0Ny40OS04LjIzLDc3LTguMjMKCQkJYzI5LjU5LDAsNjYuMTEsNi4wNyw3OC4yNyw4LjI1YzIuNDMsMC40NCw0LjE2LDIuNTUsNC4xNiw1LjAxdjI0LjU1YzAsMy41NS0zLjUzLDYuMTctNi45OCw1LjM0CgkJCWMtMTEuMDktMi42NS0zNS42NC03LjA5LTc1LjQ0LTcuMDljLTM5LjMzLDAtNjMuMTUsNC4zNC03NC4wNCw3QzIwNC43Nyw2NjEuODMsMjAxLjE2LDY1OS4xOSwyMDEuMTYsNjU1LjYxeiIvPgoJPC9nPgoJPGc+CgkJPHBhdGggY2xhc3M9InN0MSIgZD0iTTE1NTYuMjUsNTU2LjYybDYuMjQsMS45MmMtMC40MSwxLjgxLTEuMDQsMy4zLTEuOTcsNC40N2MtMC45MywxLjE3LTEuOTcsMi4xMy0zLjMyLDIuNjYKCQkJYy0xLjM1LDAuNjQtMy4wMiwwLjk2LTUuMDksMC45NmMtMi40OSwwLTQuNDctMC4zMi02LjEzLTEuMDZjLTEuNTYtMC43NS0yLjkxLTIuMDItNC4wNS0zLjk0Yy0xLjE0LTEuODEtMS43Ny00LjI2LTEuNzctNy4xMwoJCQljMC0zLjgzLDEuMDQtNi44MiwzLjAxLTguOTVjMS45Ny0yLjEzLDQuODktMy4wOSw4LjUyLTMuMDljMi45MSwwLDUuMDksMC42NCw2Ljc2LDEuODFjMS42NiwxLjE3LDIuOTEsMi45OCwzLjY0LDUuNTRsLTYuMjQsMS4zOAoJCQljLTAuMjEtMC43NS0wLjQxLTEuMjgtMC43My0xLjZjLTAuNDEtMC41My0wLjgzLTAuOTYtMS40NS0xLjI4Yy0wLjYyLTAuMzItMS4yNS0wLjQzLTEuODctMC40M2MtMS41NiwwLTIuODEsMC42NC0zLjY0LDIuMDIKCQkJYy0wLjYyLDAuOTYtMC45MywyLjU2LTAuOTMsNC41OGMwLDIuNTYsMC40MSw0LjM3LDEuMTQsNS4zMmMwLjczLDAuOTYsMS44NywxLjQ5LDMuMjIsMS40OWMxLjM1LDAsMi4zOS0wLjQzLDMuMDItMS4xNwoJCQlDMTU1NS40Myw1NTkuMTcsMTU1NS45NCw1NTguMTEsMTU1Ni4yNSw1NTYuNjJ6Ii8+CgkJPHBhdGggY2xhc3M9InN0MSIgZD0iTTE1NjQuOTgsNTU0LjQ4YzAtMy44MywxLjA0LTYuODIsMy4xMi04Ljk1YzIuMDgtMi4xMyw0Ljk5LTMuMTksOC43My0zLjE5YzMuODUsMCw2Ljc2LDEuMDYsOC44MywzLjA5CgkJCWMyLjA4LDIuMTMsMy4xMiw1LDMuMTIsOC44NGMwLDIuNzctMC40MSw1LTEuMzUsNi43MWMtMC45MywxLjctMi4xOCwzLjA5LTMuOTUsNC4wNWMtMS42NiwwLjk2LTMuODUsMS40OS02LjM0LDEuNDkKCQkJYy0yLjYsMC00LjY4LTAuNDMtNi40NC0xLjI4Yy0xLjY2LTAuODUtMy4wMS0yLjEzLTQuMTYtNC4wNUMxNTY1LjQsNTU5LjI3LDE1NjQuOTgsNTU3LjI1LDE1NjQuOTgsNTU0LjQ4eiBNMTU3Mi4wNSw1NTQuNDgKCQkJYzAsMi4zNCwwLjQyLDQuMDUsMS4yNSw1LjExczEuOTcsMS42LDMuNTMsMS42YzEuNTYsMCwyLjctMC41MywzLjU0LTEuNDljMC44My0xLjA2LDEuMjUtMi44OCwxLjI1LTUuNDMKCQkJYzAtMi4yNC0wLjQyLTMuODMtMS4zNS00Ljc5Yy0wLjgzLTEuMDYtMi4wOC0xLjQ5LTMuNTMtMS40OWMtMS40NSwwLTIuNiwwLjUzLTMuNDMsMS42CgkJCUMxNTcyLjQ3LDU1MC40NCwxNTcyLjA1LDU1Mi4xNCwxNTcyLjA1LDU1NC40OHoiLz4KCQk8cGF0aCBjbGFzcz0ic3QxIiBkPSJNMTU5Mi40Miw1NDIuNzdoOS4yNWwzLjU0LDE0LjI3bDMuNTMtMTQuMjdoOS4yNXYyMy40M2gtNS44MnYtMTcuODlsLTQuNDcsMTcuODloLTUuMmwtNC40Ny0xNy44OXYxNy44OQoJCQloLTUuODJ2LTIzLjQzSDE1OTIuNDJ6Ii8+CgkJPHBhdGggY2xhc3M9InN0MSIgZD0iTTE2MjIuNTYsNTQyLjc3aDExLjc0YzIuNiwwLDQuNDcsMC42NCw1LjcyLDEuOTJjMS4yNSwxLjI4LDEuODcsMi45OCwxLjg3LDUuMzJjMCwyLjM0LTAuNzMsNC4yNi0yLjA4LDUuNTQKCQkJYy0xLjM1LDEuMzgtMy41NCwyLjAyLTYuMzQsMi4wMmgtMy44NHY4LjczaC03LjA3VjU0Mi43N3ogTTE2MjkuNjMsNTUyLjc4aDEuNzdjMS4zNSwwLDIuMjktMC4yMSwyLjkxLTAuNzUKCQkJYzAuNTItMC41MywwLjgzLTEuMDYsMC44My0xLjgxYzAtMC43NS0wLjIxLTEuMzgtMC43My0xLjkyYy0wLjUyLTAuNTMtMS4zNS0wLjc1LTIuNy0wLjc1aC0xLjk3djUuMjJIMTYyOS42M3oiLz4KCQk8cGF0aCBjbGFzcz0ic3QxIiBkPSJNMTY0NS42Myw1NDIuNzdoNy4wN3YxNy42OGgxMS4wMnY1Ljc1aC0xOC4wOFY1NDIuNzd6Ii8+CgkJPHBhdGggY2xhc3M9InN0MSIgZD0iTTE2NjcuMjUsNTQyLjc3aDcuMDd2MjMuNDNoLTcuMDdWNTQyLjc3eiIvPgoJCTxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik0xNjkzLjQ0LDU2Mi4yNmgtOC4wMWwtMS4xNCwzLjgzaC03LjE3bDguNjItMjMuNDNoNy42OWw4LjYyLDIzLjQzaC03LjM4TDE2OTMuNDQsNTYyLjI2eiBNMTY5MS45OCw1NTcuMjUKCQkJbC0yLjQ5LTguNDFsLTIuNDksOC40MUgxNjkxLjk4eiIvPgoJCTxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik0xNzA0LjI1LDU0Mi43N2g2LjU1bDguNjIsMTIuOTl2LTEyLjk5aDYuNjV2MjMuNDNoLTYuNjVsLTguNTItMTIuODl2MTIuODloLTYuNjVWNTQyLjc3eiIvPgoJCTxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik0xNzI5LjE5LDU0Mi43N2gyMS41MXY1Ljc1aC03LjE3djE3LjY4aC03LjA3di0xNy42OGgtNy4xN3YtNS43NUgxNzI5LjE5eiIvPgoJCTxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik0xNDcxLjI0LDU3OC40NGwyMC40Ny02LjZsLTYuNjUtMTUuMTJDMTQ4MC4xOCw1NjMsMTQ3NS4yOSw1NzEuMDksMTQ3MS4yNCw1NzguNDR6IE0xNDY0LjI4LDUwOS4zMwoJCQlsLTQwLjEyLTkxLjU4bC0yOTMuNywxNy4wNGw4MS4zOCwyMjcuNDZsMTU2LjYyLTUwLjU4Yy05Ljk4LTE0LjctMTMuNjEtMzIuMTYtMi4wOC00MC42OGMxMi44OS05LjU4LDMyLjMyLDEuNDksNDQuNjksMTcuMTQKCQkJQzE0MjMuMDIsNTY3LjY5LDE0NTYuNTksNTIwLjA5LDE0NjQuMjgsNTA5LjMzeiIvPgoJCTxwYXRoIGNsYXNzPSJzdDIiIGQ9Ik0xNDE1LjAxLDQ4My45M2MxMi4yNiwwLDIyLjI0LTkuNTgsMjIuMjQtMjEuNTFjMC0xMS45My05Ljk4LTIxLjUxLTIyLjI0LTIxLjUxCgkJCWMtMTIuMjYsMC0yMi4yNCw5LjU4LTIyLjI0LDIxLjUxQzEzOTIuNzcsNDc0LjI0LDE0MDIuNzUsNDgzLjkzLDE0MTUuMDEsNDgzLjkzeiBNMTM5Ni44Myw0OTMuMmgzNi4zOHY5Ny40NGgtMzYuMzhWNDkzLjJ6Ii8+CgkJPHBhdGggY2xhc3M9InN0MiIgZD0iTTEzNzguODUsNTIxLjYzYzAuMzEsMC4xMSwwLjUyLDAsMC41Mi0wLjMyVjQ5Ni42YzAtMC4zMi0wLjIxLTAuNjQtMC41Mi0wLjg1YzAsMC00Ljc4LTMuMTktMTkuMzMtNC4wNQoJCQljLTAuNzMtMC40My0xMy41MS0wLjUzLTE2Ljk0LDBjLTUzLDQuMzctNTQuOTgsNDMuNjYtNTQuOTgsNDUuMzd2OS41OGMwLDEuMTcsMCw0MS4zMiw1NC45OCw0NC44M2M1LjQsMC40MywxNS45LDAsMTYuOTQsMAoJCQljMTIuNjgsMCwyMS40MS0zLjk0LDIxLjQxLTMuOTRjMC4zMS0wLjExLDAuNTItMC40MywwLjUyLTAuNzV2LTIzLjExYzAtMC4zMi0wLjIxLTAuNDMtMC40Mi0wLjIxYzAsMC0zLjk1LDMuMTktMjEuMiw1LjAxCgkJCWMtNC44OCwwLjUzLTcuMjgsMC4zMi05LjA0LDBjLTI0LjUzLTQuMjYtMjUuNjctMjIuNTgtMjUuNjctMjIuNThjMC0wLjMyLTAuMS0wLjg1LTAuMS0xLjA2di03LjAzYzAtMC4zMiwwLTAuODUsMC4xLTEuMDYKCQkJYzAsMCwxLjY2LTE5LjcsMjUuNjctMjEuODNoOS4wNEMxMzcwLjMyLDUxNi4zLDEzNzguODUsNTIxLjYzLDEzNzguODUsNTIxLjYzeiIvPgoJCTxwYXRoIGNsYXNzPSJzdDIiIGQ9Ik0xMTg2LjU4LDU5MC4zMWMwLDAuMzIsMC4yMSwwLjUzLDAuNTIsMC41M2gzNS40NGMwLjMxLDAsMC41Mi0wLjIxLDAuNTItMC41M3YtMjguMzMKCQkJYzAtMC4zMiwwLjIxLTAuNTMsMC41Mi0wLjUzYzAsMCw1Ni42NCw0LjE1LDU2LjY0LTM0LjcxYzAtMzAuNzctMzUuNTQtMzQuMDgtNDcuMTgtMzMuNTRjLTAuMjEsMC00NS45NCwwLTQ1Ljk0LDAKCQkJYy0wLjMxLDAtMC41MiwwLjIxLTAuNTIsMC41M1Y1OTAuMzF6IE0xMjIyLjQzLDUzOS44NHYtMjUuNDVoOC43M2MwLDAsMTIuNTgsMC41MywxMy42MSw5LjM3YzAuMjEsMC42NCwwLjIxLDUsMCw1LjIyCgkJCWMtMS42NiwxMC4zMy0xMi41OCwxMC44Ni0xMi41OCwxMC44NkgxMjIyLjQzeiIvPgoJCTxwYXRoIGNsYXNzPSJzdDMiIGQ9Ik0xNDE2LjA2LDYzNy42NWMyLjkxLDAsNS4yLDAsOC45NC0xLjdjMTIuODktNi45Miw1Ni40My0xMTUuODYsMTAyLjM3LTE0OS40YzAuMzEtMC4yMSwwLjYyLTAuNTMsMC44My0wLjg1CgkJCWMwLjMxLTAuNDMsMC4zMS0wLjg1LDAuMzEtMC44NXMwLTIuMjQtNi43Ni0yLjI0Yy00MC44NC0xLjE3LTgzLjM1LDg2LjY4LTEwNS43LDEyMS40Yy0wLjMxLDAuNDMtMS43NywwLTEuNzcsMAoJCQlzLTE0Ljk3LTE4LjEtMjcuOTYtMjUuMDJjLTAuMzEtMC4xMS0xLjc3LTAuNjQtMy4zMy0wLjUzYy0xLjA0LDAtNy4wNywxLjI4LTkuODcsNC4yNmMtMy4zMywzLjYyLTMuMjIsNS42NC0zLjIyLDEwLjAxCgkJCWMwLDAuMzIsMC4yMSwxLjgxLDAuNjIsMi41NmMzLjIyLDUuNzUsMTcuNjcsMjYuMiwyOS42MiwzNy40OEMxNDAxLjkyLDYzNC4xNCwxNDA0LjczLDYzNy42NSwxNDE2LjA2LDYzNy42NXoiLz4KCQk8cGF0aCBjbGFzcz0ic3QxIiBkPSJNMTUzOS40Miw0NTMuNjRoMzMuOTljNi43NiwwLDEyLjE2LDAuOTYsMTYuMjEsMi43N2M0LjE2LDEuOTIsNy41OSw0LjU4LDEwLjE5LDcuOTkKCQkJYzIuNywzLjUxLDQuNjgsNy41Niw1LjgyLDEyLjE0YzEuMjUsNC41OCwxLjg3LDkuNDgsMS44NywxNC43YzAsOC4wOS0wLjkzLDE0LjM4LTIuNywxOC44NWMtMS43Nyw0LjQ3LTQuMjYsOC4yLTcuNDgsMTEuMjkKCQkJYy0zLjIyLDIuOTgtNi42NSw1LTEwLjI5LDYuMDdjLTQuOTksMS4zOC05LjU2LDIuMDItMTMuNjEsMi4wMmgtMzMuOTlWNDUzLjY0eiBNMTU2Mi4yOCw0NzAuNzh2NDEuNDJoNS42MQoJCQljNC43OCwwLDguMjEtMC41MywxMC4xOS0xLjZjMS45Ny0xLjA2LDMuNjQtMi45OCw0Ljc4LTUuNjRjMS4xNC0yLjY2LDEuNzctNy4xMywxLjc3LTEzLjJjMC04LjA5LTEuMjUtMTMuNTItMy44NC0xNi41MQoJCQljLTIuNi0yLjk4LTYuNzYtNC40Ny0xMi43OC00LjQ3SDE1NjIuMjh6Ii8+CgkJPHBhdGggY2xhc3M9InN0MSIgZD0iTTE2MTMuODMsNTA0LjQzbDIxLjgzLTEuMzhjMC41MiwzLjYyLDEuNDUsNi4zOSwyLjkxLDguMzFjMi4zOSwzLjA5LDUuNzIsNC41OCwxMC4wOCw0LjU4CgkJCWMzLjIyLDAsNS44Mi0wLjc1LDcuNTgtMi4zNGMxLjc3LTEuNiwyLjctMy40MSwyLjctNS40M2MwLTEuOTItMC44My0zLjczLTIuNDktNS4zMmMtMS42Ni0xLjYtNS42MS0yLjk4LTExLjc0LTQuMzcKCQkJYy0xMC4wOC0yLjM0LTE3LjE1LTUuNDMtMjEuNTEtOS4yNnMtNi40NC04LjczLTYuNDQtMTQuN2MwLTMuOTQsMS4xNC03LjU2LDMuMzMtMTEuMDdjMi4xOC0zLjUxLDUuNTEtNi4xOCw5Ljk4LTguMgoJCQljNC40Ny0yLjAyLDEwLjUtMi45OCwxOC4xOS0yLjk4YzkuNDYsMCwxNi43MywxLjgxLDIxLjYyLDUuNDNjNC45OSwzLjYyLDcuOSw5LjM3LDguODMsMTcuMjVsLTIxLjYyLDEuMjgKCQkJYy0wLjYyLTMuNDEtMS43Ny01Ljg2LTMuNjQtNy40NWMtMS44Ny0xLjYtNC4zNi0yLjM0LTcuNTgtMi4zNGMtMi43LDAtNC42OCwwLjUzLTYuMDMsMS43Yy0xLjM1LDEuMTctMS45NywyLjU2LTEuOTcsNC4yNgoJCQljMCwxLjE3LDAuNTIsMi4zNCwxLjY2LDMuM2MxLjA0LDAuOTYsMy42NCwxLjkyLDcuNjksMi43N2M5Ljk4LDIuMjQsMTcuMTUsNC40NywyMS41MSw2LjcxYzQuMzcsMi4yNCw3LjQ4LDUuMTEsOS40Niw4LjQxCgkJCWMxLjk3LDMuMywyLjkxLDcuMTMsMi45MSwxMS4yOWMwLDQuOS0xLjM1LDkuMzctMy45NSwxMy40MmMtMi42LDQuMTUtNi4zNCw3LjI0LTExLjAyLDkuMzdjLTQuNjgsMi4xMy0xMC43MSwzLjE5LTE3Ljg4LDMuMTkKCQkJYy0xMi41NywwLTIxLjMxLTIuNDUtMjYuMTktNy40NUMxNjE3LjI2LDUxOC4zOCwxNjE0LjU2LDUxMi4xLDE2MTMuODMsNTA0LjQzeiIvPgoJCTxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik0xNjg2Ljg5LDUwNC40M2wyMS44My0xLjM4YzAuNTIsMy42MiwxLjQ1LDYuMzksMi45MSw4LjMxYzIuMzksMy4wOSw1LjcyLDQuNTgsMTAuMDgsNC41OAoJCQljMy4yMiwwLDUuODItMC43NSw3LjU5LTIuMzRjMS43Ny0xLjYsMi43LTMuNDEsMi43LTUuNDNjMC0xLjkyLTAuODMtMy43My0yLjQ5LTUuMzJjLTEuNjYtMS42LTUuNjEtMi45OC0xMS43NC00LjM3CgkJCWMtMTAuMDgtMi4zNC0xNy4xNS01LjQzLTIxLjUxLTkuMjZjLTQuMjYtMy44My02LjQ0LTguNzMtNi40NC0xNC43YzAtMy45NCwxLjE0LTcuNTYsMy4zMi0xMS4wN2MyLjE4LTMuNTEsNS41MS02LjE4LDkuOTgtOC4yCgkJCWM0LjQ3LTIuMDIsMTAuNS0yLjk4LDE4LjE5LTIuOThjOS40NiwwLDE2LjczLDEuODEsMjEuNjIsNS40M2M0Ljk5LDMuNjIsNy45LDkuMzcsOC44MywxNy4yNWwtMjEuNjIsMS4yOAoJCQljLTAuNjMtMy40MS0xLjc3LTUuODYtMy42NC03LjQ1Yy0xLjg3LTEuNi00LjM3LTIuMzQtNy41OS0yLjM0Yy0yLjcsMC00LjY4LDAuNTMtNi4wMywxLjdjLTEuMzUsMS4xNy0xLjk3LDIuNTYtMS45Nyw0LjI2CgkJCWMwLDEuMTcsMC41MiwyLjM0LDEuNjYsMy4zYzEuMDQsMC45NiwzLjY0LDEuOTIsNy42OSwyLjc3YzkuOTgsMi4yNCwxNy4xNSw0LjQ3LDIxLjUxLDYuNzFjNC4zNiwyLjI0LDcuNDgsNS4xMSw5LjQ2LDguNDEKCQkJYzEuOTcsMy4zLDIuOTEsNy4xMywyLjkxLDExLjI5YzAsNC45LTEuMzUsOS4zNy0zLjk1LDEzLjQyYy0yLjYsNC4xNS02LjM0LDcuMjQtMTEuMDIsOS4zN2MtNC42OCwyLjEzLTEwLjcsMy4xOS0xNy44OCwzLjE5CgkJCWMtMTIuNTcsMC0yMS4zMS0yLjQ1LTI2LjE5LTcuNDVDMTY5MC4yMiw1MTguMzgsMTY4Ny41Miw1MTIuMSwxNjg2Ljg5LDUwNC40M3oiLz4KCTwvZz4KCTxsaW5lIGNsYXNzPSJzdDQiIHgxPSIxMDA4LjkyIiB5MT0iNDI5LjUiIHgyPSIxMDA4LjkyIiB5Mj0iNjUwLjUiLz4KPC9nPgo8L3N2Zz4K" height="100" alt="">
					</div>
					<div class="col-12 p-2">
						<label class="input">
							<span class="input__label">Titular de la tarjeta</span>
							<input class="input__control" type="text" v-model="form.name_holder">
						</label>
					</div>
					<div class="col-12 p-2">
						<label class="input">
							<span class="input__label">Número de tarjeta</span>
							<input class="input__control" type="text" v-model="form.cardnumber">
						</label>
					</div>
					<div class="col-12 p-2">
						<label class="input">
							<span class="input__label">Fecha de exp. (02/2023)</span>
							<input class="input__control" @keyup="addCharacterExpireDate()" type="text" v-model="form.expiredate">
						</label>
					</div>
					<div class="col-12 p-2">
						<label class="input">
							<span class="input__label">CVV</span>
							<input class="input__control" type="text" v-model="form.cvv">
						</label>
					</div>
				</div>

			</div>
		</div>
		
		<div class="v-nav">
				<div class="container mt-5 d-none d-md-block p-3">
					<div class="d-flex justify-content-between">
						<div class="col-6 col-sm-5 col-md-4 col-lg-3 col-xl-2">
							<router-link :to="{name: prevStep}" class="btn btn--bold btn--block">
								Atrás
							</router-link>
						</div>
						<div class="col-6 col-sm-5 col-md-4 col-lg-3 col-xl-2">
							<button @click="finihsOrder"  class="btn btn--primary btn--bold btn--block" :disabled="!checkData">
								Pagar
							</button>
						</div>
					</div>
				</div>
				<footer class="footer">
					<div class="container text-center">
						Todos Los Derechos Reservados {{year}} Panshito®.
					</div>
				</footer>
		</div>
	</div>
	<div v-if="finish">
		<div class="alert">
			<div class="section__container py-2">
				<h5 class="text-center m-0 text-bold">¡Orden exitosa!</h5>
			</div>
		</div>

		<div class="d-flex  justify-content-center flex-wrap px-2 px-xl-5 py-5">
			<div class="col-12 col-md-6 col-lg-4 col-xl-3 pt-5">

				<div class="text-center">
					<h2 class="title">¡Su orden 
					ha sido generada 
					con éxito!</h2>

					<p class="mt-5 col-8 mx-auto">
						Le recomendamos estar pendiente del
	número de teléfono proporcionado
	para realizar la entrega.
					</p>

					<div class="col-md-8 mx-auto mt-5">
						<router-link :to="{name: 'HomeIndex'}" class="btn btn--block btn--primary">
							Hacer otro pedido
						</router-link>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div v-if="error">
		<div class="alert">
			<div class="section__container py-2">
				<h5 class="text-center m-0 text-bold">¡Ocurrio Un Error!</h5>
			</div>
		</div>

		<div class="d-flex  justify-content-center flex-wrap px-2 px-xl-5 py-5">
			<div class="col-12 col-md-6 col-lg-4 col-xl-3 pt-5">

				<div class="text-center">
					<h2 class="title">¡Ocurrio un Error Con Su orden!</h2>

					<p class="mt-5 col-8 mx-auto">
						Intenta nuevamente y verifica que tus datos esten ingresados correctamente para que tu orden pueda ser procesada
					</p>

					<div class="col-md-8 mx-auto mt-5">
						<button @click="backorder()" class="btn btn--block btn--primary">
							Hacer otro pedido
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<style lang="scss" scoped>
	.row-form{
		margin-left: -0.5rem;
		margin-right: -0.5rem;
	}
	.table__cell{
		h4{
			font-size: 1.1rem;
			font-weight: 700;
		}
		.item-cart__name{
			color: #FE2917;
			font-weight: 600;
			font-size: 0.9rem;
		}

		.btn--transparent{
			font-size: 1.3rem;
		}
	}
	
</style>